import { render, staticRenderFns } from "./cardJftc.vue?vue&type=template&id=2666aab4&scoped=true"
import script from "./cardJftc.vue?vue&type=script&lang=js"
export * from "./cardJftc.vue?vue&type=script&lang=js"
import style0 from "./cardJftc.vue?vue&type=style&index=0&id=2666aab4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2666aab4",
  null
  
)

export default component.exports